import store from "../store/index"
import {
    mqttConfig
} from "../config/mqttConfig"

let client

export async function connect() {
    client = mqtt.connect(mqttConfig['data'].url, {
        username: mqttConfig['data'].username,
        password: mqttConfig['data'].password,
    });

    await new Promise((resolve, reject) => {
        client.on("connect", () => {
            console.log("Mqtt connected ...");
            resolve()
        });
    })

    client.on("message", (topic, message) => {

        let k = topic.match(/\/[\w]+\/[\w]+\/alarm\/[\w]*$/g)[0]

        let strings = String(message).split("/");
        if (strings.length !== 3) {
            return
        }
        //console.log(String(message))
        let numbers = strings.map(s => {
            return (Number)(s)
        })

        store.commit("addAlarm", {
            key: k,
            val: numbers[1] > numbers[0] && numbers[1] < numbers[2]
        })



    });


}

//VrMaker/KingSrich/DCA63290F058/PUBLISH/B2/ZTR2/alarm/Uac

export function unsubscribe(loops) {
    client.unsubscribe(createTopics(loops))
}

export function subscribe(loops) {
    // console.log("subscribe2：", createTopics(loops))
    client.subscribe(createTopics(loops))
}

//  修改 第二层主题，根据项目信息动态修改
function createTopics(loops) {
    let db = store.state.project.projectInfo.influxDbName
    return loops.map(l => {
        return `VrMaker/${db}/+/+/${l.subLoopUrl}/alarm/#`
    })
}